export default __webpack_public_path__ + "static/media/brush.bf51898f.svg";